<template>
  <div v-if="labels.length > 1">
    <!--<div
      @click="
        $emit('toggleMenu', {
          event: $event,
          name: 'otherDisplays',
          withIcon: false,
          editedIndex: null,
          alignTopRight: true,
        })
      "
      v-if="!selected.length && !selectedLabels.length"
      class="flex justify-between p-1 text-lg border border-gray-500 rounded"
    >
      <p>Toutes les contributions</p>
      <p class="text-gray-500">Autres affichages ...</p>
    </div>-->

    <ul v-if="selectedLabels.length" class="flex">
      <li
        v-for="(label, labelCount) in labels.filter((label) => selectedLabels.includes(label.guid_text))"
        :key="label.guid_text"
        class="flex"
      >
        <div
          @click="
            $emit('toggleMenu', {
              event: $event,
              name: 'selectLabel',
              withIcon: false,
              editedIndex: null,
              alignTopRight: true,
              label: label,
            })
          "
          class="flex justify-between pl-2 pr-1 text-lg border border-gray-500 rounded cursor-pointer overflow-hidden"
          :style="
            'background-color:' +
              getLabelColors(label.guid_text).bg +
              ';color:' +
              getLabelColors(label.guid_text).font +
              ';width:' +
              labelColumnWidth +
              'px'
          "
          :id="selectedLabels.indexOf(label.guid_text)"
        >
          <TextAdjust :longText="label.text" :shortText="label.initials" :toleranceInPx="60" :refresh="isResized">
            {{ getAnswersCountForLabel(label) }}
          </TextAdjust>
          <div
            class="flex h-full items-center justify-center w-8 cursor-pointer relative"
            :style="'color:' + getLabelColors(label.guid_text).font"
          >
            <svg
              class="absolute m-auto w-8 h-8"
              xmlns="http://www.w3.org/2000/svg"
              width="59.547"
              height="34.627"
              viewBox="0 0 59.547 34.627"
            >
              <g transform="translate(0 0)">
                <path
                  d="M9.751,9.672V14.94a.786.786,0,1,1-1.572,0V8.886a.473.473,0,0,1,.079-.314.947.947,0,0,1,.393-.393c.079,0,.157-.079.236-.079H14.94a.743.743,0,0,1,.786.786.743.743,0,0,1-.786.786Z"
                  transform="translate(-8.179 -8.1)"
                  :fill="getLabelColors(label.guid_text).font"
                />
                <path
                  d="M14.154,9.673v5.268a.786.786,0,1,0,1.572,0V8.886a.473.473,0,0,0-.079-.315.947.947,0,0,0-.393-.393c-.079,0-.157-.079-.236-.079H8.965a.743.743,0,0,0-.786.786.743.743,0,0,0,.786.786Z"
                  transform="translate(43.821 -8.1)"
                  :fill="getLabelColors(label.guid_text).font"
                />
                <g transform="translate(0 27)">
                  <path
                    d="M9.751,14.153V8.886a.786.786,0,0,0-1.572,0V14.94a.473.473,0,0,0,.079.314.947.947,0,0,0,.393.393c.079,0,.157.079.236.079H14.94a.786.786,0,0,0,0-1.572Z"
                    transform="translate(-8.179 -8.099)"
                    :fill="getLabelColors(label.guid_text).font"
                  />
                  <path
                    d="M14.154,14.154V8.886a.786.786,0,1,1,1.572,0v6.054a.473.473,0,0,1-.079.315.947.947,0,0,1-.393.393c-.079,0-.157.079-.236.079H8.965a.786.786,0,0,1,0-1.573Z"
                    transform="translate(43.821 -8.1)"
                    :fill="getLabelColors(label.guid_text).font"
                  />
                </g>
              </g>
            </svg>
            {{ getSelectedAnswersCountForLabel(label) }}
          </div>
        </div>

        <img
          v-if="labelCount < selectedLabels.length - 1 && selectedLabels.length < realItemsPerLine"
          class="w-8 h-8"
          style="cursor:col-resize"
          src="../assets/icons/slider.svg"
          alt="Slider"
          @mousedown="startResize"
          @mouseup="stopResize"
        />
      </li>
    </ul>

    <ul v-if="selected.length && !selectedLabels.length" class="flex">
      <li
        v-for="label in labels"
        :key="label.guid_text"
        class="flex items-center justify-center p-1 mx-1 focus:outline-none text-lg font-normal border rounded overflow-hidden relative cursor-pointer"
        :style="
          'width:' +
            100 / labels.length +
            '%; background-color:' +
            getLabelColors(label.guid_text).bg +
            ';color:' +
            getLabelColors(label.guid_text).font +
            ';border-color:' +
            getLabelColors(label.guid_text).border
        "
        @click="associateLabelToSelectedAnswers(label)"
      >
        <img class="w-5 h-5 absolute left-0 ml-1" src="../assets/icons/paint.svg" alt="Attribuer le label" />
        <TextAdjust
          :longText="getAnswersCountForLabel(label) + ' ' + label.text"
          :shortText="getAnswersCountForLabel(label) + ' ' + label.initials"
          :toleranceInPx="60"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from "vuex"
import TextAdjust from "./utils/TextAdjust"

export default {
  props: {
    selected: Array,
    realItemsPerLine: Number,
    itemSizeWithMargins: Object,
    labelColumnWidth: Number,
  },
  data() {
    return {
      currentHeader: null,
      nextHeader: null,
      pageX: null,
      nextHeaderWidth: null,
      currentHeaderWidth: null,
      currentColumn: null,
      nextColumn: null,
      nextColumnWidth: null,
      currentColumnWidth: null,
      isResized: false,
    }
  },
  watch: {
    labelColumnWidth() {
      this.isResized = false
      this.$nextTick(() => (this.isResized = true))
    },
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels.all,
      selectedLabels: (state) => state.labels.selected,
    }),
    ...mapGetters("answers", ["getAnswersCountForLabel", "getSelectedAnswersCountForLabel"]),
    ...mapGetters("labels", ["getLabelColors"]),
  },
  methods: {
    ...mapActions("answers", ["associateLabelToSelectedAnswers"]),
    startResize(e) {
      this.isResized = false
      this.currentHeader = e.target.previousSibling
      this.nextHeader = e.target.parentElement.nextSibling.firstElementChild
      this.currentColumn = document.getElementById("grid-" + this.currentHeader.id).parentElement
      if (this.nextHeader) {
        this.nextColumn = document.getElementById("grid-" + this.nextHeader.id).parentElement
      }
      this.pageX = e.pageX
      this.currentHeaderWidth = this.currentHeader.offsetWidth
      this.currentColumnWidth = this.currentColumn.offsetWidth
      if (this.nextHeader) {
        this.nextHeaderWidth = this.nextHeader.offsetWidth
        this.nextColumnWidth = this.nextColumn.offsetWidth
      }
      document.addEventListener("mousemove", this.resize)
    },
    resize(e) {
      e.preventDefault()
      if (this.currentHeader) {
        let diffX = e.pageX - this.pageX

        if (
          !this.currentHeader.style.width.includes("%") &&
          this.currentHeaderWidth + diffX <= this.itemSizeWithMargins.width + 16
        ) {
          this.stopResize()
          return
        }

        if (this.nextHeader) {
          if (
            !this.nextHeader.style.width.includes("%") &&
            this.nextHeaderWidth - diffX <= this.itemSizeWithMargins.width + 16
          ) {
            this.stopResize()
            return
          }

          this.nextHeader.style.width = this.nextHeaderWidth - diffX + "px"
          this.nextColumn.style.width = this.nextColumnWidth - diffX + "px"
        }
        this.currentHeader.style.width = this.currentHeaderWidth + diffX + "px"
        this.currentColumn.style.width = this.currentColumnWidth + diffX + "px"
      }
    },
    stopResize() {
      this.isResized = true
      this.$forceUpdate()
      this.$emit("resizeLabels")
      document.removeEventListener("mousemove", this.resize)
      this.currentHeader = null
      this.nextHeader = null
      this.pageX = null
      this.nextHeaderWidth = null
      this.currentHeaderWidth = null
      this.currentColumn = null
      this.nextColumn = null
      this.nextColumnWidth = null
      this.currentColumnWidth = null
    },
  },
  components: {
    TextAdjust,
  },
}
</script>

<style></style>
